module.exports = __webpack_public_path__ + "static/media/location.530f22a5.svg";